var _defineProperty = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _require = require('../errors'),
    JWTClaimInvalid = _require.JWTClaimInvalid;

var secs = require('../help/secs');

var epoch = require('../help/epoch');

var isObject = require('../help/is_object');

var _verify = require('./verify');

var _require2 = require('./shared_validations'),
    isString = _require2.isString,
    isRequired = _require2.isRequired,
    isTimestamp = _require2.isTimestamp,
    isStringOrArrayOfStrings = _require2.isStringOrArrayOfStrings;

var isPayloadRequired = isRequired.bind(undefined, JWTClaimInvalid);
var isPayloadString = isString.bind(undefined, JWTClaimInvalid);
var isOptionString = isString.bind(undefined, TypeError);

var defineLazyExportWithWarning = function defineLazyExportWithWarning(obj, property, name, definition) {
  Object.defineProperty(obj, property, {
    enumerable: true,
    configurable: true,
    value: function value() {
      process.emitWarning("The ".concat(name, " API implements an IETF draft. Breaking draft implementations are included as minor versions of the jose library, therefore, the ~ semver operator should be used and close attention be payed to library changelog as well as the drafts themselves."), 'DraftWarning');
      Object.defineProperty(obj, property, {
        enumerable: true,
        configurable: true,
        value: definition
      });
      return obj[property].apply(obj, arguments);
    }
  });
};

var validateCommonOptions = function validateCommonOptions(options, profile) {
  if (!isObject(options)) {
    throw new TypeError('options must be an object');
  }

  if (!options.issuer) {
    throw new TypeError("\"issuer\" option is required to validate ".concat(profile));
  }

  if (!options.audience) {
    throw new TypeError("\"audience\" option is required to validate ".concat(profile));
  }
};

module.exports = {
  IdToken: {
    verify: function verify(token, key) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      validateCommonOptions(options, 'an ID Token');

      if ('maxAuthAge' in options) {
        isOptionString(options.maxAuthAge, 'options.maxAuthAge');
      }

      if ('nonce' in options) {
        isOptionString(options.nonce, 'options.nonce');
      }

      var unix = epoch(options.now || new Date());

      var result = _verify(token, key, _objectSpread({}, options));

      var payload = options.complete ? result.payload : result;

      if (Array.isArray(payload.aud) && payload.aud.length > 1) {
        isPayloadRequired(payload.azp, '"azp" claim', 'azp');
      }

      isPayloadRequired(payload.iat, '"iat" claim', 'iat');
      isPayloadRequired(payload.sub, '"sub" claim', 'sub');
      isPayloadRequired(payload.exp, '"exp" claim', 'exp');
      isTimestamp(payload.auth_time, 'auth_time', !!options.maxAuthAge);
      isPayloadString(payload.nonce, '"nonce" claim', 'nonce', !!options.nonce);
      isPayloadString(payload.acr, '"acr" claim', 'acr');
      isStringOrArrayOfStrings(payload.amr, 'amr');

      if (options.nonce && payload.nonce !== options.nonce) {
        throw new JWTClaimInvalid('unexpected "nonce" claim value', 'nonce', 'check_failed');
      }

      var tolerance = options.clockTolerance ? secs(options.clockTolerance) : 0;

      if (options.maxAuthAge) {
        var maxAuthAgeSeconds = secs(options.maxAuthAge);

        if (payload.auth_time + maxAuthAgeSeconds < unix - tolerance) {
          throw new JWTClaimInvalid('"auth_time" claim timestamp check failed (too much time has elapsed since the last End-User authentication)', 'auth_time', 'check_failed');
        }
      }

      if (Array.isArray(payload.aud) && payload.aud.length > 1 && payload.azp !== options.audience) {
        throw new JWTClaimInvalid('unexpected "azp" claim value', 'azp', 'check_failed');
      }

      return result;
    }
  },
  LogoutToken: {},
  AccessToken: {}
};
defineLazyExportWithWarning(module.exports.LogoutToken, 'verify', 'jose.JWT.LogoutToken.verify', function (token, key) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  validateCommonOptions(options, 'a Logout Token');

  var result = _verify(token, key, _objectSpread({}, options));

  var payload = options.complete ? result.payload : result;
  isPayloadRequired(payload.iat, '"iat" claim', 'iat');
  isPayloadRequired(payload.jti, '"jti" claim', 'jti');
  isPayloadString(payload.sid, '"sid" claim', 'sid');

  if (!('sid' in payload) && !('sub' in payload)) {
    throw new JWTClaimInvalid('either "sid" or "sub" (or both) claims must be present');
  }

  if ('nonce' in payload) {
    throw new JWTClaimInvalid('"nonce" claim is prohibited', 'nonce', 'prohibited');
  }

  if (!('events' in payload)) {
    throw new JWTClaimInvalid('"events" claim is missing', 'events', 'missing');
  }

  if (!isObject(payload.events)) {
    throw new JWTClaimInvalid('"events" claim must be an object', 'events', 'invalid');
  }

  if (!('http://schemas.openid.net/event/backchannel-logout' in payload.events)) {
    throw new JWTClaimInvalid('"http://schemas.openid.net/event/backchannel-logout" member is missing in the "events" claim', 'events', 'invalid');
  }

  if (!isObject(payload.events['http://schemas.openid.net/event/backchannel-logout'])) {
    throw new JWTClaimInvalid('"http://schemas.openid.net/event/backchannel-logout" member in the "events" claim must be an object', 'events', 'invalid');
  }

  return result;
});
defineLazyExportWithWarning(module.exports.AccessToken, 'verify', 'jose.JWT.AccessToken.verify', function (token, key) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  validateCommonOptions(options, 'a JWT Access Token');
  isOptionString(options.maxAuthAge, 'options.maxAuthAge');
  var unix = epoch(options.now || new Date());
  var typ = 'at+JWT';

  var result = _verify(token, key, _objectSpread({}, options, {
    typ: typ
  }));

  var payload = options.complete ? result.payload : result;
  isPayloadRequired(payload.iat, '"iat" claim', 'iat');
  isPayloadRequired(payload.exp, '"exp" claim', 'exp');
  isPayloadRequired(payload.sub, '"sub" claim', 'sub');
  isPayloadRequired(payload.jti, '"jti" claim', 'jti');
  isPayloadString(payload.client_id, '"client_id" claim', 'client_id', true);
  isTimestamp(payload.auth_time, 'auth_time', !!options.maxAuthAge);
  isPayloadString(payload.acr, '"acr" claim', 'acr');
  isStringOrArrayOfStrings(payload.amr, 'amr');
  var tolerance = options.clockTolerance ? secs(options.clockTolerance) : 0;

  if (options.maxAuthAge) {
    var maxAuthAgeSeconds = secs(options.maxAuthAge);

    if (payload.auth_time + maxAuthAgeSeconds < unix - tolerance) {
      throw new JWTClaimInvalid('"auth_time" claim timestamp check failed (too much time has elapsed since the last End-User authentication)', 'auth_time', 'check_failed');
    }
  }

  return result;
});